let uid = 0;

export const getUid = () => {
  uid += 1;

  return `${uid}`;
};
